import { render, staticRenderFns } from "./TAPRecordDetails.vue?vue&type=template&id=726b4a2c&scoped=true"
import script from "./TAPRecordDetails.vue?vue&type=script&lang=ts"
export * from "./TAPRecordDetails.vue?vue&type=script&lang=ts"
import style0 from "./TAPRecordDetails.vue?vue&type=style&index=0&id=726b4a2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "726b4a2c",
  null
  
)

export default component.exports